export interface AuditLog {
    id: number;
    userId?: string;
    auditType: AuditType;
    createdOn: string;
    tableName: string;
    entityId: string;
    oldValues?: string;
    newValues: string;
  }
  
  export enum AuditType {
    Detached = 0,
    Unchanged = 1,
    Deleted = 2,
    Modified = 3,
    Created = 4,
  }
  


// WEBPACK FOOTER //
// ./src/model/audit-history.ts